<template>
  <div class="container container-fluid mt-4 mb-4">
    <div class="card">
      <div class="card-body">
        <h2 class="card-title">Access Permissions</h2>

        <div class="mb-3 row">
          <label class="col-lg-2 col-form-label">Base role:</label>
          <div class="col-lg-10">
            <multiselect
              v-model="roleSelected"
              placeholder="Select a role"
              :show-labels="false"
              :options="roles"
              :allow-empty="false"
              label="title"
              track-by="id"
            />
          </div>
        </div>
        <h3>Permissions</h3>
      </div>

      <ul class="list-data no-links no-hover">
        <li
          v-for="(abilities, abilityGroup) in groupedAbilities"
          :key="abilityGroup"
        >
          <div class="row">
            <div class="col-sm-4 col-md-3 col-xl-2 align-items-start">
              <h4 class="mb-0">{{ abilityGroup | capitalise }}</h4>
            </div>

            <div class="col-sm-8 col-md-9 col-xl-10">
              <div class="flex-grow-1">
                <div
                  v-for="ability in abilities"
                  class="form-group row"
                  :key="ability.id"
                >
                  <div class="col">
                    <ability-input
                      v-model="selectedAbilities"
                      :ability="ability"
                      :selectedRole="baseRole"
                    />
                  </div>
                  <div class="col-lg-4 col-xl-3">
                    <!-- <label class="sr-only">Owner level</label>
                    <multiselect
                      v-model="singleSelect2"
                      placeholder="Select a role"
                      :preselect-first="true"
                      :show-labels="false"
                      :options="['All', 'Created by user']"
                    /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="card-body text-right">
        <c-button
          type="button"
          @click="handleSaveChanges"
          class="btn btn-success"
          >Save Changes</c-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '@/utils'
import { mapState } from 'vuex'
import { groupBy, cloneDeep } from 'lodash'
import { helperComputed as roleComputed, helperMethods as roleMethods } from '@/vuex/modules/roles'
import AbilityInput from '@/components/users/AbilityInput.vue'
import { toast } from '@chameleon/chameleon-vue'

export default {
  components: {
    AbilityInput
  },

  data () {
    return {
      abilities: [],
      selectedAbilities: [],
      baseRole: null
    }
  },

  async created () {
    await this.getRoles()
    this.baseRole = this.user.role
    this.selectedAbilities = cloneDeep(this.user.abilities)
    const response = await http.get('abilities')
    this.abilities = response.data.data
  },

  computed: {
    ...roleComputed,
    ...mapState('user', ['user']),

    groupedAbilities () {
      if (this.roleSelected) {
        return groupBy(this.abilities, 'group')
      }
      return null
    },

    roleSelected: {
      get () {
        if (!this.baseRole) {
          return null
        }
        return this.roles.find(option => option.id === this.baseRole.id)
      },

      set (option) {
        if (this.user.role && option.name === this.user.role.name) {
          this.selectedAbilities = this.user.abilities
          this.baseRole = this.user.role
        } else {
          this.baseRole = option
          this.selectedAbilities = option.abilities
        }
      }
    }
  },

  watch: {
    baseRole: {
      handler (role) {
        role.abilities.forEach((ability) => {
          const abilityNotSelected = this.selectedAbilities.find(existing => existing.id === ability.id) === undefined

          if (abilityNotSelected) {
            this.selectedAbilities.push(ability)
          }
        })
      }
    }
  },

  methods: {
    ...roleMethods,

    async handleSaveChanges () {
      try {
        const payload = {
          role: this.baseRole.id,
          selected_abilities: this.selectedAbilities
        }
        await http.put(`users/${this.user.id}/permissions`, payload)
        // await this.getUser(this.user.id)
        toast('Role successfully updated', 'success')
      } catch (error) {
        toast(error, 'danger')
      }
    }
  }
}
</script>
